import React from 'react';
import { getStyles } from '../../Dropdown/MenuItem';
const MenuOption = ({ children, value, checked = false, onClick }) => {
    const styles = getStyles();
    return (React.createElement("label", { className: styles.root },
        React.createElement("input", { key: value, type: "radio", value: value, checked: checked, onClick: onClick, readOnly: true }),
        children));
};
export default MenuOption;
//# sourceMappingURL=MenuOption.js.map